import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {QuoteCreationRequest} from "../_models/QuoteCreationRequest";
import {Quote} from "../_models/Quote";
import {Injectable} from "@angular/core";
import {QuoteSearchCriteria} from "../_models/QuoteSearchCriteria";
import {PagedResponse} from "../_models";
import {Observable} from "rxjs";
import {BespokeQuoteCreationRequest} from "../_models/BespokeQuoteCreationRequest";
import {Customer} from "../_models/Customer";
import {PlanImage} from "../_models/PlanImage";
import {Plan} from "../_models/Plan";
import {CreateRemoveAndRefitRequest} from "../_models/CreateRemoveAndRefitRequest";

@Injectable({providedIn: 'root'})
export class QuoteService {

  constructor(private httpClient: HttpClient, private oauthService: OAuthService) {
  }

  createQuote(request: QuoteCreationRequest) {
    return this.httpClient.post<Quote>('/api/quotes/create', request);
  }

  createBespokeQuote(request: BespokeQuoteCreationRequest) {
    return this.httpClient.post<Quote>('/api/quotes/createbespoke', request);
  }

  getQuotes(quoteSearchCriteria: QuoteSearchCriteria): Observable<PagedResponse<Quote>> {
    return this.httpClient.post<PagedResponse<Quote>>('/api/quotes/search', quoteSearchCriteria);
  }

  getQuote(id: string): Observable<Quote> {
    return this.httpClient.get<Quote>('/api/quotes/' + id);
  }

  searchCustomers(query: string): Observable<PagedResponse<Customer>> {
    return this.httpClient.get<PagedResponse<Customer>>('/api/quotes/searchcustomers?query=' + query);
  }

  getPlanImage(planId: string): Observable<PlanImage> {
    return this.httpClient.get<PlanImage>('/api/quotes/planimg/' + planId);
  }

  getPlan(planId: string) {
    return this.httpClient.get<Plan>('/api/quotes/plan/' + planId);
  }

  markAsFinal(id: number) {
    return this.httpClient.post('/api/quotes/markfinalplan/' + id, {});
  }

  createContract(quoteId: string) {
    return this.httpClient.post('/api/quotes/' + quoteId + '/createcontract', {});
  }

  createRemoveAndRefit(request: CreateRemoveAndRefitRequest) {
    return this.httpClient.post<Quote>('/api/quotes/createremoveandrefit', request);
  }

  getQuoteAndLatestPlan(id: string): Observable<Quote> {
    return this.httpClient.get<Quote>('/api/quotes/getquoteandlatestplan/' + id);
  }
}
